// extracted by mini-css-extract-plugin
export var pillWrapper = "_xp-0";
export var showOverflow = "_xp-1";